import { SubscriptionDetailsContants } from './SubscriptionDetails.constants';

const initialState = {
  subscriptionDetails: {},
  accountBillPlan: {},
  subscriptionAllplansDetails: {}
};

const SubscriptionDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    // --- Get Subscription Details
    case SubscriptionDetailsContants.GET_SUBSCRIPTION_DETAILS_REQUEST:
      return {
        ...state,
        subscriptionDetails: {
          loading: true,
          error: false
        }
      };

    case SubscriptionDetailsContants.GET_SUBSCRIPTION_DETAILS_SUCCESS:
      return {
        ...state,
        subscriptionDetails: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case SubscriptionDetailsContants.GET_SUBSCRIPTION_DETAILS_ERROR:
      return {
        ...state,
        subscriptionDetails: {
          loading: false,
          error: true
        }
      };

    case SubscriptionDetailsContants.GET_SUBSCRIPTION_ALL_PLANS_DETAILS_REQUEST:
      return {
        ...state,
        subscriptionAllplansDetails: {
          loading: true,
          error: false
        }
      };

    case SubscriptionDetailsContants.GET_SUBSCRIPTION_ALL_PLANS_DETAILS_SUCCESS:
      return {
        ...state,
        subscriptionAllplansDetails: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case SubscriptionDetailsContants.GET_SUBSCRIPTION_ALL_PLANS_DETAILS_ERROR:
      return {
        ...state,
        subscriptionAllplansDetails: {
          loading: false,
          error: true
        }
      };

    // --- GET account bill plan
    case SubscriptionDetailsContants.GET_ACCOUNT_BILL_PLAN_REQUEST:
      return {
        ...state,
        accountBillPlan: {
          loading: true,
          error: false
        }
      };

    case SubscriptionDetailsContants.GET_ACCOUNT_BILL_PLAN_SUCCESS:
      return {
        ...state,
        accountBillPlan: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case SubscriptionDetailsContants.GET_ACCOUNT_BILL_PLAN_ERROR:
      return {
        ...state,
        accountBillPlan: {
          loading: false,
          error: true
        }
      };

    case SubscriptionDetailsContants.GET_SUBSCRIPTION_BILLPLANDETAILS_SUCCESS:
      return {
        ...state,
        billingPlanDetails: {
          ...action.payload
        }
      };

    case SubscriptionDetailsContants.GET_SUBSCRIPTION_CREDITPLANDETAILS_SUCCESS:
      return {
        ...state,
        billingCreditDetails: {
          ...action.payload
        }
      };

    case SubscriptionDetailsContants.GET_SUBSCRIPTION_OVERALLBILLPLAN_SUCCESS:
      return {
        ...state,
        overallBillPlanDetails: {
          ...action.payload
        }
      };

    default:
      return state;
  }
};

export default SubscriptionDetailsReducer;
